// import PriceboardManager from "@/controllers/gridManager/PriceboardManager";

import PriceboardComponents from "../components/Priceboard/PriceboardComponents";

export default function PriceboardLayout() {
    return (
        // <PriceboardManager />
        <PriceboardComponents isShowIndexChart={true} isShowPriBoard={true}  />
    );
}